export default function ({ $gtm, store }) {
	if (store.state.merchant.settings.integrations.google_tag_manager && store.state.merchant.settings.integrations.google_tag_manager.enabled &&
		store.state.merchant.settings.integrations.google_tag_manager.container_id) {
		$gtm.init(store.state.merchant.settings.integrations.google_tag_manager.container_id)
	}
}
